import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { AppClientRoutingModule } from "../app-routing.module";
import { AppClientComponent } from "../app.component";
import { UserAccessComponent } from "./user-access.component";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { ResetPasswordComponent } from "./resetPassword/reset-password.component";
import { ResetPasswordDataService } from "../_dataservices/ResetPasswordDataService";
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    RegisterComponent,
    LoginComponent,
    UserAccessComponent,
    ResetPasswordComponent
  ],
  exports: [
    RecaptchaModule,
    LoginComponent,
    RegisterComponent,
    UserAccessComponent,
    ResetPasswordComponent
  ],
  imports: [
    FormsModule,
    AppClientRoutingModule,
    CommonModule
  ],
  providers: [
    ResetPasswordDataService
  ],
  bootstrap: [AppClientComponent]
})

export class UserAccessModule { }
